import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const subLotControllerEndpoint = 'NegotiationSubLot';


export class NegotiationSubLotAPI {

  getSubLotById(L2Id) {
    return axios.get(getBackendURL() + subLotControllerEndpoint + '/GetSubLotById?L2Id=' + L2Id);
  }

  createSubLot(dto) {
    return axios.post(getBackendURL() + subLotControllerEndpoint + '/CreateL2', dto);
  }

  updateSubLot(dto) {
    return axios.put(getBackendURL() + subLotControllerEndpoint + '/UpdateL2', dto);
  }

  cloneSubLot(L2Id) {
    return axios.put(getBackendURL() + subLotControllerEndpoint + '/CloneL2?L2Id=' + L2Id);
  }

  deleteSubLot(L2Id) {
    return axios.delete(getBackendURL() + subLotControllerEndpoint + '/DeleteL2?L2Id=' + L2Id);
  }

  updateAgendamentoNumRefL2(dto) {
    return axios.put(getBackendURL() + subLotControllerEndpoint + '/UpdateAgendamentoNumRefL2', dto);
  }
}

export default NegotiationSubLotAPI


// WEBPACK FOOTER //
// ./src/API/NegotiationSubLotAPI.js